jQuery(document).ready(function ($) {
    // Header
    const bubbleNumElem = $(".cart-count-bubble > span[aria-hidden]");
    bubbleNumElem.attr("data-count", bubbleNumElem.text());
});

// Custom: Loading analytics based on user preference, including DNT 
window.Shopify.loadFeatures([{
    name: 'consent-tracking-api',
    version: '0.1',
}], error => {
    if (error) {
        return console.error("Failed loading consent-tracking-api", error);
    }

    const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
    if(currentConsent.analytics == '' && navigator.doNotTrack) {
        window.Shopify.customerPrivacy.setTrackingConsent({
            "analytics":    false,
            "marketing":    false,
            },
            () => console.log("Consent updated due to DNT browser settings")
        );

    setTimeout(() => document.querySelector("#shopify-pc__banner__btn-decline").click(), 500);
    }

    if(window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        loadAnalytics();
    }

    document.addEventListener("visitorConsentCollected", event => {
        if(event.detail.analyticsAllowed) loadAnalytics();
    });
});

var analyticsLoaded = 0;
function loadAnalytics() {
    if(analyticsLoaded) return;
    analyticsLoaded = 1;

    // Meta
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '530852406431775');
    fbq('track', 'PageView');
}


